export const labelConfig = {
    home: ["PageTitles.home"],
    ricercaFocolai: ["PageTitles.ricerca_focolai"],
    ricercaSegnalazioni: ["PageTitles.ricerca_segnalazioni"],
    associaSegnalazioni: ["PageTitles.associa_segnalazioni"],
    ricercaContactTracing:["PageTitles.ricerca_contactTracing"],
    InformazioniFocolaio: ["PageTitles.ins_focolaio", "PageTitles.modifica_focolaio"],
    wizardSegnalazione: ["PageTitles.ins_segnalazione", "PageTitles.schedaMalaria", "PageTitles.schedaInfluenza", "PageTitles.schedaEpatite", "PageTitles.schedaTubercolosi", "PageTitles.schedaMorbillo", "PageTitles.schedaMIB", "PageTitles.schedaDefault", "PageTitles.schedaCartacea", "PageTitles.schedaRosolia"],
    ricercaSegnalazioniHIV: ["PageTitles.ricerca_segnalazioni_hiv"],
    gestioneDuplicatiHIV: ["PageTitles.gestione_duplicati_hiv"],
    formHIV: ["PageTitles.inserisci_segnalazione_hiv", "PageTitles.modifica_segnalazione_hiv"],
    notauthorized: ["PageTitles.notauthorized"],
    default: ["PageTitles.default"],
}
